var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCloseMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M94.912 147.776l368.896 362.432L89.792 881.92a36.992 36.992 0 00-.576 51.84 35.84 35.84 0 0051.008.64l375.424-373.184L882.368 932.8a36.608 36.608 0 0051.584.448 36.224 36.224 0 00.448-51.328L566.144 508.8 934.08 142.208a37.056 37.056 0 00.512-51.904 35.712 35.712 0 00-50.944-.576l-369.344 368-370.368-363.84a35.072 35.072 0 00-50.496 1.408 37.824 37.824 0 001.472 52.48z"
  })));
}

export default SvgCloseMenu;